import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Teleport as _Teleport } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = {
    class: "nav nav-underline mb-3",
    role: "tablist"
};
const _hoisted_3 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_4 = { class: "tab-content rounded bg-white p-3 mb-4" };
const _hoisted_5 = {
    class: "tab-pane fade show active",
    id: "details-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "details-tab",
    tabindex: "0"
};
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-lg-6 col-12" };
const _hoisted_8 = { class: "form-floating mb-3" };
const _hoisted_9 = { class: "form-floating mb-3" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = { class: "form-floating mb-3" };
const _hoisted_13 = { class: "form-floating mb-3" };
const _hoisted_14 = { class: "form-floating mb-3" };
const _hoisted_15 = { class: "form-floating mb-3" };
const _hoisted_16 = ["value"];
const _hoisted_17 = { class: "form-check mb-3" };
const _hoisted_18 = { class: "col-lg-6 col-12" };
const _hoisted_19 = { class: "d-flex justify-content-end" };
const _hoisted_20 = { key: 0 };
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
    key: 0,
    class: "d-flex flex-wrap"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-x-circle text-muted",
    viewBox: "0 0 16 16"
};
const _hoisted_25 = {
    class: "tab-pane fade",
    id: "user-tab-pane",
    role: "tabpanel",
    "aria-labelledby": "user-tab",
    tabindex: "0"
};
const _hoisted_26 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_27 = { class: "mb-1" };
const _hoisted_28 = { class: "mb-1" };
const _hoisted_29 = { class: "mb-3" };
const _hoisted_30 = {
    class: "modal fade",
    id: "createAddress",
    tabindex: "-1",
    "aria-labelledby": "createAddressModalLabel",
    "aria-hidden": "true"
};
const _hoisted_31 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_32 = { class: "modal-content" };
const _hoisted_33 = { class: "modal-body" };
const _hoisted_34 = { class: "form-floating mb-3" };
const _hoisted_35 = { class: "form-floating mb-3" };
const _hoisted_36 = { class: "form-floating mb-3" };
const _hoisted_37 = { class: "form-floating mb-3" };
const _hoisted_38 = { class: "form-floating mb-3" };
const _hoisted_39 = { class: "form-floating mb-3" };
const _hoisted_40 = { class: "form-floating mb-3" };
const _hoisted_41 = ["value"];
const _hoisted_42 = { class: "form-check" };
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import YesNoIcon from '@/Shared/YesNoIcon.vue';
import { responseMessages } from '@/Composables/responseMessages';
import { Modal } from 'bootstrap';
import { Select, useConfirm } from 'primevue';
import axios from 'axios';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        customer: Object,
        languages: Object,
        countries: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const createAddressModal = ref(null);
        const availableUsers = ref([]);
        const editCustomerForm = useForm({
            customerNo: props.customer ? props.customer.customerNo : null,
            company: props.customer ? props.customer.company : null,
            title: props.customer ? props.customer.title : null,
            firstname: props.customer ? props.customer.firstname : null,
            lastname: props.customer ? props.customer.lastname : null,
            email: props.customer ? props.customer.email : null,
            phone: props.customer ? props.customer.phone : null,
            newsletterAbo: props.customer ? props.customer.newsletterAbo : false,
            lang: props.customer ? props.customer.lang : 'de'
        });
        const createAddressForm = useForm({
            company: null,
            firstname: null,
            lastname: null,
            address: null,
            city: null,
            zipcode: null,
            country: null,
            isDefault: false
        });
        onMounted(() => {
            const modalElement = document.getElementById('createAddress');
            if (modalElement) {
                createAddressModal.value = new Modal(modalElement);
            }
        });
        function updateCustomer() {
            if (props.customer == null) {
                return;
            }
            editCustomerForm.transform((data) => ({
                customer_no: data.customerNo,
                company: data.company,
                title: data.title,
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email,
                phone: data.phone,
                newsletter_abo: data.newsletterAbo,
                lang: data.lang,
            })).submit('put', route('admin.customers.update', props.customer.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeCustomer() {
            confirm.require({
                message: 'Soll der Kunde wirklich gelöscht werden?',
                header: 'Kunde löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.customer == null) {
                        return;
                    }
                    router.delete(route('admin.customers.destroy', props.customer.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function createAddress() {
            if (props.customer == null) {
                return;
            }
            createAddressForm.transform((data) => ({
                company: data.company,
                firstname: data.firstname,
                lastname: data.lastname,
                address: data.address,
                city: data.city,
                zipcode: data.zipcode,
                country: data.country,
                is_default: data.isDefault
            })).submit('post', route('admin.customers.addresses.store', props.customer.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    createAddressForm.reset();
                    if (createAddressModal.value) {
                        createAddressModal.value.hide();
                    }
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function setDefaultAdress(address) {
            router.put(route('admin.customers.addresses.setDefault', address.uuid), {}, {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeAddress(address) {
            confirm.require({
                message: 'Soll die Adresse wirklich gelöscht werden?',
                header: 'Adresse löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.customers.addresses.destroy', address.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function loadAvailableUsers() {
            axios.post(route('admin.users.load')).then((response) => {
                availableUsers.value = response.data;
                availableUsers.value.push({
                    uuid: 0,
                    name: 'Kein Benutzer'
                });
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function updateUserConnection() {
            router.put(route('admin.customers.user.update', props.customer.uuid), {
                user_uuid: props.customer.userUuid
            }, {
                preserveScroll: true,
                onSuccess: page => {
                    loadAvailableUsers();
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Kunden-Details" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Kunde: " + _toDisplayString(props.customer.company) + " (" + _toDisplayString(props.customer.firstname) + " " + _toDisplayString(props.customer.lastname) + ")", 1),
                        _createElementVNode("ul", _hoisted_2, [
                            _cache[21] || (_cache[21] = _createElementVNode("li", {
                                class: "nav-item",
                                role: "presentation"
                            }, [
                                _createElementVNode("button", {
                                    class: "nav-link active",
                                    id: "details-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#details-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "details-tab-pane",
                                    "aria-selected": "true"
                                }, "Details")
                            ], -1)),
                            _createElementVNode("li", _hoisted_3, [
                                _createElementVNode("button", {
                                    class: "nav-link",
                                    id: "user-tab",
                                    "data-bs-toggle": "tab",
                                    "data-bs-target": "#user-tab-pane",
                                    type: "button",
                                    role: "tab",
                                    "aria-controls": "user-tab-pane",
                                    "aria-selected": "false",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (loadAvailableUsers()))
                                }, "Benutzer-Account")
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(updateCustomer, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_8, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "customerNo",
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editCustomerForm).customerNo) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editCustomerForm).customerNo]
                                                ]),
                                                _cache[22] || (_cache[22] = _createElementVNode("label", { for: "customerNo" }, "Kundennr.", -1)),
                                                _cache[23] || (_cache[23] = _createElementVNode("p", { class: "form-text" }, "Wird bei Nicht-Ausfüllen automatisch generiert", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_9, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "company",
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editCustomerForm).company) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editCustomerForm).company]
                                                ]),
                                                _cache[24] || (_cache[24] = _createElementVNode("label", { for: "company" }, "Firma (optional)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_10, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "title",
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editCustomerForm).title) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _unref(editCustomerForm).title]
                                                ]),
                                                _cache[25] || (_cache[25] = _createElementVNode("label", { for: "title" }, "Titel (optional)", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_11, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "firstname",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editCustomerForm).firstname) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editCustomerForm).firstname]
                                                ]),
                                                _cache[26] || (_cache[26] = _createElementVNode("label", { for: "firstname" }, "Vorname", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "lastname",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editCustomerForm).lastname) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editCustomerForm).lastname]
                                                ]),
                                                _cache[27] || (_cache[27] = _createElementVNode("label", { for: "lastname" }, "Nachname", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "email",
                                                    class: "form-control",
                                                    id: "email",
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editCustomerForm).email) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editCustomerForm).email]
                                                ]),
                                                _cache[28] || (_cache[28] = _createElementVNode("label", { for: "email" }, "E-Mail", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    id: "phone",
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(editCustomerForm).phone) = $event)),
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, _unref(editCustomerForm).phone]
                                                ]),
                                                _cache[29] || (_cache[29] = _createElementVNode("label", { for: "phone" }, "Telefon", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: "lang",
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(editCustomerForm).lang) = $event)),
                                                    required: ""
                                                }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.languages, (language) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            value: language.code
                                                        }, _toDisplayString(language.name), 9, _hoisted_16));
                                                    }), 256))
                                                ], 512), [
                                                    [_vModelSelect, _unref(editCustomerForm).lang]
                                                ]),
                                                _cache[30] || (_cache[30] = _createElementVNode("label", { for: "lang" }, "Sprache", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_17, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    value: "1",
                                                    id: "newsletterAbo",
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(editCustomerForm).newsletterAbo) = $event))
                                                }, null, 512), [
                                                    [_vModelCheckbox, _unref(editCustomerForm).newsletterAbo]
                                                ]),
                                                _cache[31] || (_cache[31] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "newsletterAbo"
                                                }, "Newsletter-Abonnent", -1))
                                            ]),
                                            _cache[32] || (_cache[32] = _createElementVNode("button", {
                                                type: "submit",
                                                class: "btn btn-success d-inline-flex align-items-center"
                                            }, [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-check2",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                ]),
                                                _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                            ], -1))
                                        ], 32),
                                        _createElementVNode("button", {
                                            class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                            onClick: removeCustomer
                                        }, [...(_cache[33] || (_cache[33] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-x-circle",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                    _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                ], -1),
                                                _createElementVNode("span", { class: "ms-2" }, "Kunde löschen", -1)
                                            ]))])
                                    ]),
                                    _createElementVNode("div", _hoisted_18, [
                                        _cache[38] || (_cache[38] = _createElementVNode("button", {
                                            class: "btn btn-secondary d-inline-flex align-items-center",
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#createAddress"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-plus-lg",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", {
                                                    "fill-rule": "evenodd",
                                                    d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                                })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Neue Adresse")
                                        ], -1)),
                                        _createVNode(_unref(DataTable), {
                                            dataKey: "id",
                                            value: props.customer.addresses,
                                            stripedRows: "",
                                            responsiveLayout: "scroll",
                                            globalFilterFields: ['company', 'lastname', 'address', 'city', 'zipcode', 'country', 'isDefault'],
                                            filters: tableFilter.value,
                                            "onUpdate:filters": _cache[11] || (_cache[11] = ($event) => ((tableFilter).value = $event)),
                                            paginator: true,
                                            rows: 10,
                                            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                            rowsPerPageOptions: [10, 25, 50, 150],
                                            currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                                        }, {
                                            header: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_19, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                                        placeholder: "Suche",
                                                        style: { "width": "250px" }
                                                    }, null, 512), [
                                                        [_vModelText, tableFilter.value['global'].value]
                                                    ])
                                                ])
                                            ]),
                                            empty: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                                    _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                                ]))]),
                                            loading: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                                    _createTextVNode(" Einträge werden geladen ... ", -1)
                                                ]))]),
                                            default: _withCtx(() => [
                                                _createVNode(_unref(Column), {
                                                    header: "#",
                                                    sortable: true
                                                }, {
                                                    body: _withCtx((slotProps) => [
                                                        _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_unref(Column), {
                                                    field: "company",
                                                    header: "Firma",
                                                    sortable: true,
                                                    sortField: "company"
                                                }),
                                                _createVNode(_unref(Column), {
                                                    header: "Name",
                                                    sortable: true,
                                                    sortField: "lastname"
                                                }, {
                                                    body: _withCtx((slotProps) => [
                                                        _createTextVNode(_toDisplayString(slotProps.data.firstname) + " " + _toDisplayString(slotProps.data.lastname), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_unref(Column), {
                                                    field: "address",
                                                    header: "Adresse",
                                                    sortable: true,
                                                    sortField: "address"
                                                }),
                                                _createVNode(_unref(Column), {
                                                    field: "city",
                                                    header: "Stadt",
                                                    sortable: true,
                                                    sortField: "city"
                                                }),
                                                _createVNode(_unref(Column), {
                                                    field: "zipcode",
                                                    header: "Postleitzahl",
                                                    sortable: true,
                                                    sortField: "zipcode"
                                                }),
                                                _createVNode(_unref(Column), {
                                                    field: "country",
                                                    header: "Land",
                                                    sortable: true,
                                                    sortField: "country"
                                                }),
                                                _createVNode(_unref(Column), {
                                                    header: "Standard-Adresse",
                                                    sortable: true,
                                                    sortField: "isDefault"
                                                }, {
                                                    body: _withCtx((slotProps) => [
                                                        (!slotProps.data.isDefault)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                                _createElementVNode("button", {
                                                                    class: "btn",
                                                                    onClick: ($event) => (setDefaultAdress(slotProps.data))
                                                                }, [
                                                                    _createVNode(YesNoIcon, {
                                                                        answer: slotProps.data.isDefault
                                                                    }, null, 8, ["answer"])
                                                                ], 8, _hoisted_21)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (slotProps.data.isDefault)
                                                            ? (_openBlock(), _createBlock(YesNoIcon, {
                                                                key: 1,
                                                                answer: slotProps.data.isDefault
                                                            }, null, 8, ["answer"]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_unref(Column), { header: "" }, {
                                                    body: _withCtx((slotProps) => [
                                                        (slotProps.data.canRemove)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                                _createElementVNode("button", {
                                                                    class: "btn",
                                                                    onClick: ($event) => (removeAddress(slotProps.data))
                                                                }, [...(_cache[36] || (_cache[36] = [
                                                                        _createElementVNode("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            width: "16",
                                                                            height: "16",
                                                                            fill: "currentColor",
                                                                            class: "bi bi-x-circle text-danger",
                                                                            viewBox: "0 0 16 16"
                                                                        }, [
                                                                            _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                                            _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                                        ], -1)
                                                                    ]))], 8, _hoisted_23)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (!slotProps.data.canRemove)
                                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_24, [...(_cache[37] || (_cache[37] = [
                                                                    _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }, null, -1),
                                                                    _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" }, null, -1)
                                                                ]))]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["value", "filters"])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                (props.customer.user)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _cache[41] || (_cache[41] = _createElementVNode("h5", { class: "fw-bold text-primary mb-3" }, "Zugeordneter Benutzer", -1)),
                                        _createElementVNode("p", _hoisted_27, [
                                            _cache[39] || (_cache[39] = _createElementVNode("strong", null, "Name:", -1)),
                                            _createTextVNode(" " + _toDisplayString(props.customer.user.firstname) + " " + _toDisplayString(props.customer.user.lastname), 1)
                                        ]),
                                        _createElementVNode("p", _hoisted_28, [
                                            _cache[40] || (_cache[40] = _createElementVNode("strong", null, "E-Mail:", -1)),
                                            _createTextVNode(" " + _toDisplayString(props.customer.user.email), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[43] || (_cache[43] = _createElementVNode("h5", { class: "fw-bold text-primary mb-3" }, "Neuen Benutzer zuordnen", -1)),
                                _createElementVNode("div", _hoisted_29, [
                                    _createVNode(_unref(Select), {
                                        class: "w-100",
                                        modelValue: props.customer.userUuid,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((props.customer.userUuid) = $event)),
                                        options: availableUsers.value,
                                        filter: "",
                                        optionLabel: "name",
                                        optionValue: "uuid",
                                        placeholder: "Benutzer wählen"
                                    }, null, 8, ["modelValue", "options"])
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-success d-inline-flex align-items-center",
                                    onClick: updateUserConnection
                                }, [...(_cache[42] || (_cache[42] = [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-check2",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                        ], -1),
                                        _createElementVNode("span", { class: "ms-2" }, "Speichern", -1)
                                    ]))])
                            ])
                        ])
                    ]),
                    _: 1
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createAddressModalLabel"
                                    }, "Neue Adresse"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(createAddress, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_33, [
                                        _createElementVNode("div", _hoisted_34, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "newAddressCompany",
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(createAddressForm).company) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createAddressForm).company]
                                            ]),
                                            _cache[44] || (_cache[44] = _createElementVNode("label", { for: "newAddressCompany" }, "Firma", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "newAddressFirstname",
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(createAddressForm).firstname) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createAddressForm).firstname]
                                            ]),
                                            _cache[45] || (_cache[45] = _createElementVNode("label", { for: "newAddressFirstname" }, "Vorname", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "newAddressLastname",
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(createAddressForm).lastname) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createAddressForm).lastname]
                                            ]),
                                            _cache[46] || (_cache[46] = _createElementVNode("label", { for: "newAddressLastname" }, "Nachname", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_37, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "newAddressStreet",
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(createAddressForm).address) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createAddressForm).address]
                                            ]),
                                            _cache[47] || (_cache[47] = _createElementVNode("label", { for: "newAddressStreet" }, "Adresse", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_38, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "newAddressZipcode",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(createAddressForm).zipcode) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createAddressForm).zipcode]
                                            ]),
                                            _cache[48] || (_cache[48] = _createElementVNode("label", { for: "newAddressZipcode" }, "Postleitzahl", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_39, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "newAddressCity",
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(createAddressForm).city) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createAddressForm).city]
                                            ]),
                                            _cache[49] || (_cache[49] = _createElementVNode("label", { for: "newAddressCity" }, "Stadt", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_40, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "newAddressCountry",
                                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(createAddressForm).country) = $event))
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.countries, (country) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: country.id
                                                    }, _toDisplayString(country.name), 9, _hoisted_41));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(createAddressForm).country]
                                            ]),
                                            _cache[50] || (_cache[50] = _createElementVNode("label", { for: "newAddressCountry" }, "Land", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_42, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "newAddressIsDefault",
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(createAddressForm).isDefault) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(createAddressForm).isDefault]
                                            ]),
                                            _cache[51] || (_cache[51] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "newAddressIsDefault"
                                            }, "Standard-Adresse?", -1))
                                        ])
                                    ]),
                                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
